import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

import ApproveConfirmModal from './ApproveConfirmModal';
import RejectMemberModal from './RejectMemberModal';
import { useAdmin } from '../../contexts/AdminContext';

const mockMembers = [
  // Active Members
  {
    id: 101,
    membershipNumber: 'HDL001',
    firstName: 'Robert',
    lastName: 'Wilson',
    email: 'robert.wilson@example.com',
    membershipType: 'individual',
    status: 'active',
    joinDate: '2023-01-15',
    renewalDate: '2024-01-15',
  },
  {
    id: 102,
    membershipNumber: 'HDL002',
    firstName: 'Alice',
    lastName: 'Cooper',
    email: 'alice.cooper@example.com',
    membershipType: 'family',
    status: 'active',
    joinDate: '2023-02-20',
    renewalDate: '2024-02-20',
  },
  {
    id: 103,
    membershipNumber: 'HDL003',
    firstName: 'Thomas',
    lastName: 'Harris',
    email: 'thomas.harris@example.com',
    membershipType: 'individual',
    status: 'active',
    joinDate: '2023-03-10',
    renewalDate: '2024-03-10',
  },
  {
    id: 104,
    membershipNumber: 'HDL004',
    firstName: 'Patricia',
    lastName: 'Murphy',
    email: 'patricia.murphy@example.com',
    membershipType: 'youth',
    status: 'active',
    joinDate: '2023-04-05',
    renewalDate: '2024-04-05',
  },
  {
    id: 105,
    membershipNumber: 'HDL005',
    firstName: 'George',
    lastName: 'Baker',
    email: 'george.baker@example.com',
    membershipType: 'individual',
    status: 'active',
    joinDate: '2023-05-15',
    renewalDate: '2024-05-15',
  },
  {
    id: 106,
    membershipNumber: 'HDL006',
    firstName: 'Helen',
    lastName: 'Foster',
    email: 'helen.foster@example.com',
    membershipType: 'family',
    status: 'active',
    joinDate: '2023-06-20',
    renewalDate: '2024-06-20',
  },
  {
    id: 107,
    membershipNumber: 'HDL007',
    firstName: 'Richard',
    lastName: 'Edwards',
    email: 'richard.edwards@example.com',
    membershipType: 'individual',
    status: 'active',
    joinDate: '2023-07-01',
    renewalDate: '2024-07-01',
  },
  {
    id: 108,
    membershipNumber: 'HDL008',
    firstName: 'Margaret',
    lastName: 'Phillips',
    email: 'margaret.phillips@example.com',
    membershipType: 'youth',
    status: 'active',
    joinDate: '2023-08-12',
    renewalDate: '2024-08-12',
  },
  // Pending Members (from AdminContext)
  {
    id: 1,
    membershipNumber: 'PENDING001',
    firstName: 'John',
    lastName: 'Smith',
    email: 'john.smith@example.com',
    membershipType: 'individual',
    status: 'pending',
    joinDate: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
    renewalDate: '',
  },
  {
    id: 2,
    membershipNumber: 'PENDING002',
    firstName: 'Mary',
    lastName: 'Johnson',
    email: 'mary.johnson@example.com',
    membershipType: 'family',
    status: 'pending',
    joinDate: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString(),
    renewalDate: '',
  },
  {
    id: 3,
    membershipNumber: 'PENDING003',
    firstName: 'David',
    lastName: 'Williams',
    email: 'david.williams@example.com',
    membershipType: 'individual',
    status: 'pending',
    joinDate: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(),
    renewalDate: '',
  },
  {
    id: 4,
    membershipNumber: 'PENDING004',
    firstName: 'Sarah',
    lastName: 'Brown',
    email: 'sarah.brown@example.com',
    membershipType: 'youth',
    status: 'pending',
    joinDate: new Date(Date.now() - 5 * 60 * 60 * 1000).toISOString(),
    renewalDate: '',
  },
  {
    id: 5,
    membershipNumber: 'PENDING005',
    firstName: 'Michael',
    lastName: 'Davis',
    email: 'michael.davis@example.com',
    membershipType: 'individual',
    status: 'pending',
    joinDate: new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString(),
    renewalDate: '',
  },
  {
    id: 6,
    membershipNumber: 'PENDING006',
    firstName: 'Emma',
    lastName: 'Wilson',
    email: 'emma.wilson@example.com',
    membershipType: 'family',
    status: 'pending',
    joinDate: new Date(Date.now() - 7 * 60 * 60 * 1000).toISOString(),
    renewalDate: '',
  },
  {
    id: 7,
    membershipNumber: 'PENDING007',
    firstName: 'James',
    lastName: 'Taylor',
    email: 'james.taylor@example.com',
    membershipType: 'individual',
    status: 'pending',
    joinDate: new Date(Date.now() - 8 * 60 * 60 * 1000).toISOString(),
    renewalDate: '',
  },
  {
    id: 8,
    membershipNumber: 'PENDING008',
    firstName: 'Sophie',
    lastName: 'Anderson',
    email: 'sophie.anderson@example.com',
    membershipType: 'youth',
    status: 'pending',
    joinDate: new Date(Date.now() - 9 * 60 * 60 * 1000).toISOString(),
    renewalDate: '',
  },
  {
    id: 9,
    membershipNumber: 'PENDING009',
    firstName: 'Oliver',
    lastName: 'Thomas',
    email: 'oliver.thomas@example.com',
    membershipType: 'individual',
    status: 'pending',
    joinDate: new Date(Date.now() - 10 * 60 * 60 * 1000).toISOString(),
    renewalDate: '',
  },
  {
    id: 10,
    membershipNumber: 'PENDING010',
    firstName: 'Emily',
    lastName: 'Martin',
    email: 'emily.martin@example.com',
    membershipType: 'family',
    status: 'pending',
    joinDate: new Date(Date.now() - 11 * 60 * 60 * 1000).toISOString(),
    renewalDate: '',
  },
  {
    id: 11,
    membershipNumber: 'PENDING011',
    firstName: 'Daniel',
    lastName: 'White',
    email: 'daniel.white@example.com',
    membershipType: 'individual',
    status: 'pending',
    joinDate: new Date(Date.now() - 12 * 60 * 60 * 1000).toISOString(),
    renewalDate: '',
  },
  {
    id: 12,
    membershipNumber: 'PENDING012',
    firstName: 'Lucy',
    lastName: 'Clark',
    email: 'lucy.clark@example.com',
    membershipType: 'youth',
    status: 'pending',
    joinDate: new Date(Date.now() - 13 * 60 * 60 * 1000).toISOString(),
    renewalDate: '',
  },
  // Members with upcoming renewals
  {
    id: 201,
    membershipNumber: 'HDL021',
    firstName: 'Peter',
    lastName: 'Morgan',
    email: 'peter.morgan@example.com',
    membershipType: 'individual',
    status: 'active',
    joinDate: '2023-01-01',
    renewalDate: new Date(Date.now() + 15 * 24 * 60 * 60 * 1000).toISOString(), // 15 days from now
  },
  {
    id: 202,
    membershipNumber: 'HDL022',
    firstName: 'Laura',
    lastName: 'Bennett',
    email: 'laura.bennett@example.com',
    membershipType: 'family',
    status: 'active',
    joinDate: '2023-01-05',
    renewalDate: new Date(Date.now() + 20 * 24 * 60 * 60 * 1000).toISOString(), // 20 days from now
  },
  {
    id: 203,
    membershipNumber: 'HDL023',
    firstName: 'Kevin',
    lastName: 'Hughes',
    email: 'kevin.hughes@example.com',
    membershipType: 'youth',
    status: 'active',
    joinDate: '2023-01-10',
    renewalDate: new Date(Date.now() + 25 * 24 * 60 * 60 * 1000).toISOString(), // 25 days from now
  },
];

function MembersList() {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const { approveMember, rejectMember } = useAdmin();
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const [approveModalOpen, setApproveModalOpen] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [filters, setFilters] = useState({
    search: '',
    membershipType: '',
    status: searchParams.get('status') || '',
    dateRange: 'all',
  });

  // Update filters when URL parameters change
  useEffect(() => {
    const status = searchParams.get('status');
    if (status) {
      setFilters(prev => ({
        ...prev,
        status,
      }));
    }
  }, [searchParams]);

  const [sortConfig, setSortConfig] = useState({
    key: 'membershipNumber',
    direction: 'asc',
  });

  const handleFilterChange = e => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value,
    }));

    // Update URL when status filter changes
    if (name === 'status') {
      if (value) {
        setSearchParams({ status: value });
      } else {
        setSearchParams({});
      }
    }
  };

  const handleSort = key => {
    setSortConfig(prev => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
    }));
  };

  const filteredMembers = mockMembers
    .filter(member => {
      const searchMatch =
        member.membershipNumber.toLowerCase().includes(filters.search.toLowerCase()) ||
        member.firstName.toLowerCase().includes(filters.search.toLowerCase()) ||
        member.lastName.toLowerCase().includes(filters.search.toLowerCase()) ||
        member.email.toLowerCase().includes(filters.search.toLowerCase());

      const typeMatch = !filters.membershipType || member.membershipType === filters.membershipType;
      const statusMatch = !filters.status || member.status === filters.status;

      let dateMatch = true;
      if (filters.dateRange !== 'all') {
        const today = new Date();
        const renewalDate = new Date(member.renewalDate);
        const monthsDiff = (renewalDate - today) / (1000 * 60 * 60 * 24 * 30);

        switch (filters.dateRange) {
          case '1month':
            dateMatch = monthsDiff <= 1;
            break;
          case '3months':
            dateMatch = monthsDiff <= 3;
            break;
          case '6months':
            dateMatch = monthsDiff <= 6;
            break;
          default:
            dateMatch = true;
        }
      }

      return searchMatch && typeMatch && statusMatch && dateMatch;
    })
    .sort((a, b) => {
      if (sortConfig.direction === 'asc') {
        return a[sortConfig.key] > b[sortConfig.key] ? 1 : -1;
      }
      return a[sortConfig.key] < b[sortConfig.key] ? 1 : -1;
    });

  const SortHeader = ({ label, sortKey }) => (
    <th
      className="px-4 py-2 cursor-pointer hover:bg-gray-50 text-hdlcc-textDark transition-colors"
      onClick={() => handleSort(sortKey)}
    >
      <div className="flex items-center space-x-1">
        <span>{label}</span>
        {sortConfig.key === sortKey && (
          <span className="text-hdlcc-accentRed">{sortConfig.direction === 'asc' ? '↑' : '↓'}</span>
        )}
      </div>
    </th>
  );

  const handleApprove = async () => {
    const success = await approveMember(selectedMember.id);
    if (success) {
      setApproveModalOpen(false);
      setSelectedMember(null);
    }
  };

  const handleReject = async reason => {
    const success = await rejectMember(selectedMember.id, reason);
    if (success) {
      setRejectModalOpen(false);
      setSelectedMember(null);
    }
  };

  const openApproveModal = (e, member) => {
    e.stopPropagation();
    setSelectedMember(member);
    setApproveModalOpen(true);
  };

  const openRejectModal = (e, member) => {
    e.stopPropagation();
    setSelectedMember(member);
    setRejectModalOpen(true);
  };

  return (
    <div className="p-6">
      <div className="mb-6 space-y-4">
        <h2 className="text-2xl font-bold text-hdlcc-textDark uppercase">Members List</h2>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div>
            <input
              type="text"
              name="search"
              value={filters.search}
              onChange={handleFilterChange}
              placeholder="Search members..."
              className="w-full p-2 border rounded bg-white text-hdlcc-textDark border-gray-300 focus:border-hdlcc-accentRed focus:outline-none transition-colors"
            />
          </div>

          <div>
            <select
              name="membershipType"
              value={filters.membershipType}
              onChange={handleFilterChange}
              className="w-full p-2 border rounded bg-white text-hdlcc-textDark border-gray-300 focus:border-hdlcc-accentRed focus:outline-none transition-colors"
            >
              <option value="">All Types</option>
              <option value="individual">Individual</option>
              <option value="joint">Joint</option>
              <option value="youth">Youth</option>
            </select>
          </div>

          <div>
            <select
              name="status"
              value={filters.status}
              onChange={handleFilterChange}
              className="w-full p-2 border rounded bg-white text-hdlcc-textDark border-gray-300 focus:border-hdlcc-accentRed focus:outline-none transition-colors"
            >
              <option value="">All Statuses</option>
              <option value="active">Active</option>
              <option value="expired">Expired</option>
              <option value="pending">Pending</option>
            </select>
          </div>

          <div>
            <select
              name="dateRange"
              value={filters.dateRange}
              onChange={handleFilterChange}
              className="w-full p-2 border rounded bg-white text-hdlcc-textDark border-gray-300 focus:border-hdlcc-accentRed focus:outline-none transition-colors"
            >
              <option value="all">All Dates</option>
              <option value="1month">Renewal within 1 month</option>
              <option value="3months">Renewal within 3 months</option>
              <option value="6months">Renewal within 6 months</option>
            </select>
          </div>
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full bg-hdlcc-bgWhite shadow-card border border-gray-200 rounded-lg overflow-hidden">
          <thead>
            <tr className="bg-gray-100 border-b border-gray-200">
              <SortHeader label="Membership No." sortKey="membershipNumber" />
              <SortHeader label="Name" sortKey="lastName" />
              <SortHeader label="Email" sortKey="email" />
              <SortHeader label="Type" sortKey="membershipType" />
              <SortHeader label="Status" sortKey="status" />
              <SortHeader label="Join Date" sortKey="joinDate" />
              <SortHeader label="Renewal Date" sortKey="renewalDate" />
              <th className="px-4 py-2 text-hdlcc-textDark">Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredMembers.map(member => (
              <tr
                key={member.id}
                onClick={() => navigate(`/admin/members/${member.id}`)}
                className="border-t border-gray-200 hover:bg-gray-50 cursor-pointer transition-colors text-hdlcc-textDark"
              >
                <td className="px-4 py-2">{member.membershipNumber}</td>
                <td className="px-4 py-2">{`${member.firstName} ${member.lastName}`}</td>
                <td className="px-4 py-2">{member.email}</td>
                <td className="px-4 py-2 capitalize">{member.membershipType}</td>
                <td className="px-4 py-2">
                  <span
                    className={`px-2 py-1 rounded text-sm ${
                      member.status === 'active'
                        ? 'bg-green-900 text-green-200 border border-green-500'
                        : member.status === 'expired'
                          ? 'bg-red-900 text-red-200 border border-red-500'
                          : 'bg-yellow-900 text-yellow-200 border border-yellow-500'
                    }`}
                  >
                    {member.status}
                  </span>
                </td>
                <td className="px-4 py-2">{new Date(member.joinDate).toLocaleDateString()}</td>
                <td className="px-4 py-2">
                  {member.renewalDate ? new Date(member.renewalDate).toLocaleDateString() : '-'}
                </td>
                <td className="px-4 py-2">
                  {member.status === 'pending' && (
                    <div className="flex space-x-2">
                      <button
                        className="bg-hdlcc-accentGreen text-white px-2 py-1 rounded hover:bg-green-600 transition-colors"
                        onClick={e => openApproveModal(e, member)}
                      >
                        Approve
                      </button>
                      <button
                        className="bg-hdlcc-accentRed text-white px-2 py-1 rounded hover:bg-red-600 border border-gray-200 transition-colors"
                        onClick={e => openRejectModal(e, member)}
                      >
                        Reject
                      </button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <RejectMemberModal
        isOpen={rejectModalOpen}
        onClose={() => {
          setRejectModalOpen(false);
          setSelectedMember(null);
        }}
        onReject={handleReject}
        memberName={selectedMember ? `${selectedMember.firstName} ${selectedMember.lastName}` : ''}
      />
      <ApproveConfirmModal
        isOpen={approveModalOpen}
        onClose={() => {
          setApproveModalOpen(false);
          setSelectedMember(null);
        }}
        onConfirm={handleApprove}
        memberName={selectedMember ? `${selectedMember.firstName} ${selectedMember.lastName}` : ''}
      />
    </div>
  );
}

export default MembersList;
